import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
// import { RegisterComponent } from './views/register/register.component';
import { ForgetPasswordComponent } from './views/forget-password/forget-password.component';
//import { RegisprospectComponent } from './views/regisprospect/regisprospect.component';
//import { NotifikasiComponent } from './views/regisprospect/notifikasi.component';
import { AuthGuard } from './api/auth.guard';
//import { RegisnewComponent } from './views/regisnew/regisnew.component';
//import { RegisorderComponent } from './views/regisnew/regisorder.component';
//import { RegisproductComponent } from './views/regisnew/regisproduct.component';
//import { RegispayComponent } from './views/regisnew/regispay.component';
//import { RegisComponent } from './views/regisnew/regis.component';
//import { RegisrefComponent } from './views/regisnew/regisref.component';
import { RegisterComponent } from './views/sgs/register/register.component';


/* module / projecta purchase iptv (retail playmedia)*/
import { PurchaseComponent } from './views/external/purchase/purchase.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    // redirectTo: 'regis',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: 'forget_password', 
    component: ForgetPasswordComponent
  },
  // {
  //   path: 'register/:refid', 
  //   component: RegisprospectComponent
  // },
  /*{
    path: 'notifikasi/:id',
    component: NotifikasiComponent
  },
  {
    path: 'regis/:refid',
    component: RegisrefComponent
  },
  {
    path: 'regis2/:prospekindex',
    component: RegisorderComponent
  },
  {
    path: 'regis3/:prospekindex',
    component: RegisproductComponent
  },
  {
    path: 'regis4/:prospekindex',
    component: RegispayComponent
  },
  {
    path: 'regis',
    component: RegisComponent
  },
  {
    path: 'purchase',
    component: PurchaseComponent
  },
  */
  
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'adminproduct',
        loadChildren: () => import('./views/adminproduct/adminproduct.module').then(m => m.AdminproductModule)
      },
      {
        path: 'adminsgs',
        loadChildren: () => import('./views/adminsgs/adminsgs.module').then(m => m.AdminsgsModule)
      },
      {
        path: 'sgs',
        loadChildren: () => import('./views/sgs/sgs.module').then(m => m.SgsModule)
      },
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      }
    ]
  },
  // { path: '**', component: P404Component }
  {path: '**', redirectTo:'', pathMatch: 'full' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
